<template>
  <va-card stripe="gray" :title="$t('events.subscriptions')">
    <template slot="actions">
      <va-button color="gray" to="/admin/app-subscriptions" icon="fa fa-eye"/>
    </template>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
    </va-data-table>
  </va-card>
</template>

<script>
import debounce from 'lodash/debounce'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'SubscriptionLocationTable',
  mixins: [errorHandlerMixin],
  data () {
    return {
      subscriptions: [].slice(),
      loading: false,
      term: null,
      mode: 0,
      openSpotModal: false,
    }
  },
  props: {
    locationId: Number,
  },
  computed: {
    fields () {
      return [{
        name: 'name',
        title: 'name',
      }, {
        name: 'isGlobal',
        title: 'global',
      }, {
        name: 'isDefault',
        title: 'default',
      }, {
        name: 'isUserShow',
        title: 'client view',
      }]
    },
    modeOptions () {
      return [{
        value: 0,
        label: this.$t('dashboard.table.brief'),
      }]
    },
    filteredData () {
      return this.subscriptions
    },
  },
  methods: {
    getStatusColor (status) {
      if (status === 'paid') {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },
    resolveUser (user) {
      this.loading = true

      setTimeout(() => {
        const idx = this.subscriptions.findIndex(u => u.id === user.id)
        this.subscriptions.splice(idx, 1)
        this.loading = false

        this.showToast(this.$t('dashboard.table.resolved'), {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 1500,
        })
      }, 500)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
    async initSubscriptions (subscriptions) {
      this.subscriptions.splice(0, this.subscriptions.length, ...subscriptions)
    },
  },
  mounted () {
    this.$store.dispatch('getLocationAppSubscriptions', this.locationId)
      .then((resp) => this.initSubscriptions(resp.data.message))
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style lang="scss">
</style>
